import { useParams } from "react-router-dom";
import P404 from "../404/404";
import Edition2023 from "./2023/Edition2023";
import Edition2024 from "./2024/Edition2024";
import Edition2025 from "./2025/Edition2025";

interface EditionProps {
	lang: string;
}

const Edition: React.FC<EditionProps> = (props:EditionProps) => {
	const {year} = useParams<string>()
	if (year==='2023') return <Edition2023 lang={props.lang}></Edition2023>
	if (year==='2024') return <Edition2024 lang={props.lang}></Edition2024>
	if (year==='2025') return <Edition2025 lang={props.lang}></Edition2025>
	return <P404 lang={props.lang}></P404>
}

export default Edition